import { CSSProperties, PropsWithChildren } from 'react';
import clsx from 'clsx';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './errorMessage.module.scss';

export function ErrorMessage({
  children,
  className,
  style,
}: PropsWithChildren & { className?: string; style?: CSSProperties }) {
  return (
    <span className={clsx(styles['error'], className)} style={style}>
      <GoogleFontIcon className={styles['error__icon']} name="report" solid />
      {children}
    </span>
  );
}
